import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MembershipFooter from "./MembershipFooter";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
  },
  iconWrapper: {
    display: "inline",
    margin: theme.spacing(0, 1),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    color: "white",
  },
  textAction: {
    color: "var(--gc-action-strong)",
  },
  link: {
    color: "inherit",
    textDecoration: "none",
  },
  text: {
    color: "oklch(55.4% .046 257.417)",
  },
}));

function MembershipIntro({ onLogin, onSignUp }) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.wrapper}>
        <Typography variant="body1">
          Sei già registrato a <strong>GiocamondoClub?</strong>
        </Typography>
        <Typography variant="body2" className={classes.text}>
          <br />
          Ti ricordiamo che se sei già registrato, inserendo le tue credenziali,{" "}
          <strong>
            molti dei campi sottostanti saranno automaticamente compilati
          </strong>
          .<br />
          {/* Se hai ricevuto la nostra e-mail di accesso utilizza i dati che ti
          abbiamo inviato oppure compila il form di registrazione rispondendo
          “No”. */}
          <strong>Importante per partecipanti INPS: </strong>la prenotazione
          deve essere effettuata a nome del titolare INPS (CF ed email) il quale
          deve essere anche lo stesso iscritto al GiocamondoClub.
          <br />
          <strong>NB: </strong> l’iscrizione al Giocamondo Club ti permetterà di
          gestire tutta la documentazione necessaria alla conferma della
          pratica.
        </Typography>
        <div>
          <FormControlLabel
            value="si"
            label="Sì"
            control={<Radio onChange={onLogin} />}
          />

          <FormControlLabel
            value="no"
            label="No"
            control={<Radio onChange={onSignUp} />}
          />
        </div>
      </div>

      <MembershipFooter />
    </React.Fragment>
  );
}

MembershipIntro.propTypes = {
  onLogin: PropTypes.func.isRequired,
  onSignUp: PropTypes.func.isRequired,
};

export default MembershipIntro;
